<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/part.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Onboard Organization</h3>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ totalOnboardOrganization }}</h2>
                  </div>
                </div>

                   <div class="col-md-3">
                  <div class="total-count">
                    <select
                      class="form-control"
                      id="approve_status"
                      [(ngModel)]="filterData.approve_status"
                      (change)="setFilterData($event)"
                    >
                      <option value="ALL">ALL</option>
                      <option value="PENDING">PENDING</option>
                      <option selected value="APPROVED">APPROVED</option>
                      <option selected value="REJECTED">REJECTED</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <div id="table" class="table-responsive">
                <table
                  datatable
                  id="onboard_org"
                  [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table"
                  width="100%"
                  
                >
                  <thead>
                    <tr>
                      <th>#Sl</th>
                      <th>Action</th>
                      <th>Approval Status</th>
                      <th>Status</th>
                      <th>Approved/Rejected Date</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>State</th>
                      <th>District</th>
                      <th>Created Date</th>
                        <th>Updated Date</th>
                    </tr>
                  </thead>

                  <tbody *ngIf="onboardOrgList?.length != 0">
                    <tr
                      *ngFor="let item of onboardOrgList; let i = index"
                      [attr.data-index]="i"
                    >
                      <td>{{ getRowNumber(i) }}</td>

                      <td class="action">
                        <label class="switch">
                          <input
                            type="checkbox"
                            (change)="delete(item)"
                            [checked]="item.status == '1'"
                          />
                          <span class="slider round"></span>
                        </label>

                        <button
                          type="button"
                          class="btn text-dark btn-sm rounded bg-light"
                          (click)="onOnboardView(this.onboardOrgList[i].id)"
                        >
                          <i class="fa fa-eye"></i></button
                        >&nbsp;
                      </td>

                        <td>
                        {{ item.approve_status }}
                      </td>

                      <td>
                        <span
                          *ngIf="item.status == '1'"
                          class="badge badge-success badge-pill"
                          >Active</span
                        >
                        <span
                          *ngIf="item.status == '0'"
                          class="badge badge-danger badge-pill"
                          >In active</span
                        >
                      </td>

                    

                       <td>
                        {{ item.approved_rejected_date || "-"}}
                      </td>
                      <td>
                        {{ item.name || "-" }}
                      </td>

                      <td>{{ item.type_relation?.name || "-" }}</td>
                      <td>
                        {{ item.state_relation?.state_name || "-" }}
                      </td>
                      <td>{{ item.district_relation?.city_name || "-" }}</td>

                      <td>{{ item.created_at || "-"}}</td>

                       <td>{{ item.updated_at || "-"}}</td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="onboardOrgList?.length == 0">
                    <tr>
                      <td colspan="12" class="no-data-available text-center">
                        No data available!
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
